import CommunityFeedbackGallery from "../components/community-feedback-gallery";

export default <template>
  <CommunityFeedbackGallery @itemType="wish" @outletArgs={{@model}} />
</template>;
